import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "./BackgroundSlider.scss";
import img1 from "../../../assets/images/bghome-a.png";
import img2 from "../../../assets/images/bg2.png";
import img3 from "../../../assets/images/bg3.png";
import Header from "../../appLayout/header";
import { SignatureIcon } from "../../../assets/icons/SignatureIcon";
import { useLocation, useNavigate } from "react-router-dom";
const BackgroundSlider = () => {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(location.pathname);
  const slides = [
    { img: img1, position: "position-mobile" },
    { img: img2, position: "" },
    { img: img3, position: "position-mobile" },
  ];
  const navigate = useNavigate();
  return (
    <section className="background-slider">
      <Swiper
        modules={[Pagination, Autoplay, EffectFade]}
        effect="fade"
        pagination={{ clickable: true }}
        loop={true}
        autoplay={{
          delay: 2000, // 5 secondes entre chaque slide
          disableOnInteraction: false, // continue autoplay même après interaction
        }}
        className="mySwiper">
        {slides.map((img, index) => (
          <SwiperSlide key={index}>
            <div
              className={`slide-bg ${img.position}`}
              style={{ backgroundImage: `url(${img.img})` }}>
              <div className=" pt-md-3 p-md-5 p-0">
                <Header />
              </div>
              <div
                className="row w-100 d-flex -items-center ms-0 p-md-0 p-4"
                style={{ height: "80vh" }}>
                <div className="col-lg-1"></div>
                <div className="col-lg-5 ">
                  <div className=" d-flex flex-column justify-content-center h-100">
                    <div className="glass-content d-none d-md-block">
                      {" "}
                      <h1>
                        Sublimez-vous <br />
                        au Naturel
                      </h1>
                      <p>
                      Alma Secret – la dermo-cosmétique espagnole haut de gamme qui allie science et nature depuis 2016.
Des formules bio, certifiées ECOCERT et non testées sur les animaux, enrichies en actifs naturels grâce à notre procédé exclusif Infinity Booster®, pour sublimer votre peau en profondeur.

Sans parabènes, sans sulfates, respectueuses de votre peau et de la planète.
                      </p>
                      <button
                        className="btn-shop"
                        onClick={() => {
                          navigate("/all-products");
                          window.scrollTo(0, 0);
                        }}>
                        <SignatureIcon />
                        Achetez maintenant
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row w-100 d-flex -items-center ms-0">
                <div className="col-lg-1"></div>
                <div className="col-lg-5">
                  <div className=" d-flex flex-column justify-content-end  h-100 ">
                    <div className="glass-category d-none d-md-block">
                      <button
                        className={`btn-category ${
                          activeMenu === "/" ? "active" : ""
                        }`}
                        onClick={() => {
                          navigate("/all-products?type=bestSeller");
                          window.scrollTo(0, 0);
                        }}>
                        BEST SELLERS
                      </button>
                      <button
                        className={`btn-category ms-2 ${
                          activeMenu === "/nouveautes" ? "active" : ""
                        }`}
                        onClick={() => {
                          navigate("/all-products?type=nouveaux");
                          window.scrollTo(0, 0);
                        }}>
                        NOUVEAUTES
                      </button>
                      <button
                        className={`btn-category ms-2 ${
                          activeMenu === "/promotions" ? "active" : ""
                        }`}
                        onClick={() => {
                          navigate("/all-products?type=promotions");
                          window.scrollTo(0, 0);
                        }}>
                        PROMOTIONS
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div
        className="row w-100 d-flex -items-center ms-0 p-md-0 p-4 position-mobile-bg"
        style={{ height: "80vh" }}>
        <div className="col-lg-1"></div>
        <div className="col-lg-5 ">
          <div className=" d-flex flex-column justify-content-center h-100">
            <div className="glass-content d-md-none d-block">
              {" "}
              <h1>
                Sublimez-vous <br />
                au Naturel
              </h1>
              <p>
                Alma Secret est une marque espagnole de cosmétique haut de
                gamme, formulée avec des ingrédients naturels, biologiques et
                actifs puissants. Sans parabènes, sans sulfates, sans cruauté
                animale.
              </p>
              <button
                className="btn-shop"
                onClick={() => {
                  navigate("/all-products");
                  window.scrollTo(0, 0);
                }}>
                <SignatureIcon />
                Achetez maintenant
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BackgroundSlider;
